import React from 'react'

const Bookings = () => {
  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-5'>
      {/* Map appointments with company card */}
      Bookings
    </div>
  )
}

export default Bookings
